<template>
  <div id="pre-paid" style="padding: 40px 0 0px 0 ">
    <div class="upper-content">
      <lines-card :error="error" :load="load" :data="data.html" />
      <additional-info-card :load="load" :error="error" :data="data.additionalInfo" />
    </div>
  </div>
</template>
<script>
import LinesCard from '../../components/cards/LinesCard'
// import AdditionalInfoCard from '../../components/cards/AdditionalInfoCard'
import ProductCategoryRepository from '../../repositories/ProductCategoryRepository'
export default {
  components: { LinesCard },
  data () {
    return {
      productRepo: new ProductCategoryRepository(),
      data: {
        html: '',
        additionalInfo: []
      },
      load: false,
      error: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.load = true
      try {
        const response = await this.productRepo.getByType(1)
        if (response.data.status === 200) {
          this.data.html = response.data.data.description
          for (let i = 0; i < response.data.data.additionalInfos.length; i++) {
            this.data.additionalInfo.push(response.data.data.additionalInfos[i].description)
          }
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.load = false
    }
  }
}
</script>
<style lang="scss" scoped>
.upper-content {
  background-image: url("../../assets/images/line-page-circles.svg");
  background-position: right;
}
</style>
